import { isNull } from 'lodash';
import AbstractService from './abstractService';

// Singleton instance
let instance = null;

const _SERVICE_UNAVAILABLE_ = new Error({ message : 'Service Unavailable' });

export default class OverviewService extends AbstractService {
	static setup(baseURL, options) {
		instance = new OverviewService(baseURL, options);
	}

	static getInstance() {
		return instance;
	}

	constructor(baseURL, options) {
		super(baseURL, options);
		this.endpoint = 'dashboard';
	}

	static getOverviewData(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getOverviewData(...params);
	}

	_getOverviewData() {
		return this.get({
			endpoint : `${this.endpoint}`,
		});
	}
}
